import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineProDetailMeetingHistoryList のスタイル
 */
export const hotlineProDetailMeetingHistoryListStyle = tv({
    slots: {
        item: [textStyle({ color: 'base', size: 'sm' }), 'list-disc'],
        list: ['flex flex-col gap-8', 'pl-20'],
        noDataBase: [textStyle({ color: 'base', size: 'sm' })],
    },
});
